import { useCallback } from 'react'
import _ from 'lodash'

import { getServingsInfo } from '../../utils'

export default ({
  onChange,
  field: variationField,
  servings,
  model,
  availableUnits,
  selectedIngredient,
}) => {
  const handleRecalculateQuantity = useCallback(() => {
    const currentServings = _.get(model, `values[${variationField}].${selectedIngredient}.servings`)

    const {
      defaultServing,
      step,
      unitID,
      quantity,
    } = getServingsInfo(servings, currentServings, availableUnits)

    const result = (servings || []).reduce((acc, value) => ({
      ...acc,
      [value]: {
        quantity: value === defaultServing ? quantity : step * value,
        unitID,
      },
    }), {})

    onChange({
      target: {
        value: result,
        name: `values[${variationField}].${selectedIngredient}.servings`,
      },
    })
  },[availableUnits, model, onChange, selectedIngredient, servings, variationField])

  return handleRecalculateQuantity

}
